var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "01 Icons/01 Small/warning") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01-Icons/01-Small/warning",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "warning",
    transform: "translate(4.000000, 4.641394)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8488604,13.1920043 L9.11330541,0.666070959 C8.63589237,-0.222023653 7.3641083,-0.222023653 6.88630005,0.666070959 L0.151140272,13.1920043 C-0.0597225026,13.5841949 -0.0493405128,14.0584807 0.178481366,14.4410417 C0.406303244,14.8236026 0.818066396,15.0581874 1.26286451,15.0588235 L14.7351601,15.0588235 C15.1803106,15.0588235 15.5927112,14.8245753 15.821012,14.4418903 C16.0493129,14.0592053 16.0598895,13.5845054 15.8488604,13.1920043 Z M8.00000034,13.1195795 C7.56346401,13.1195795 7.2095814,12.7652003 7.2095814,12.3280513 C7.2095814,11.8909024 7.56346401,11.5365232 8.00000034,11.5365232 C8.43653666,11.5365232 8.79041928,11.8909024 8.79041928,12.3280513 C8.79041928,12.5379776 8.70714323,12.7393059 8.55891093,12.8877463 C8.41067862,13.0361866 8.20963247,13.1195795 8.00000034,13.1195795 Z M8.85839531,5.15878488 L8.63154507,9.98710675 C8.63154507,10.3368259 8.34843898,10.6203293 7.99920992,10.6203293 C7.64998086,10.6203293 7.36687477,10.3368259 7.36687477,9.98710675 L7.14002453,5.1607637 L7.14002453,5.1607637 C7.12972358,4.92774205 7.21438313,4.70052509 7.3745912,4.53121241 C7.53479928,4.36189974 7.75681265,4.2650156 7.98972489,4.26277487 L7.99802429,4.26277487 C8.2325543,4.26265392 8.45694033,4.35854602 8.61911888,4.52820177 C8.78129742,4.69785752 8.86717093,4.92652939 8.85681447,5.16115947 L8.85839531,5.15878488 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarning);
export default __webpack_public_path__ + "static/media/ic-warning.fcdea2a209305aa801eb3777af276e9f.svg";
export { ForwardRef as ReactComponent };